import {render as renderTosc5SearchForms} from './modules/tosc5-search-form';
import {render as renderTosc5Embeds} from './modules/tosc5/embed';

renderTosc5SearchForms();
renderTosc5Embeds();
